import {
  ApiSlugs,
  ListPagination,
  UserRegistrationDto,
  UserRegistrationId,
  UserRegistrationSummaryDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class UserRegistrationsAdminConnector extends ApiConnector<
  UserRegistrationDto,
  UserRegistrationDto,
  UserRegistrationId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.USER_REGISTRATIONS);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<UserRegistrationSummaryDto[]> =>
      this.apiCaller.getRequest<UserRegistrationSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
